import Field, { AggregationType, FieldType, validAggregationByType } from "@dto/fields";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { TW_FieldAggregationSection, TW_FieldAggregationSection_Label, TW_FieldAggregationSection_Select } from "@utils/twClasses";

export interface FieldAggregationFormProps {
    fieldType: FieldType | undefined,
    fieldTypeItems: Map<string, any> | undefined,
    fieldAggregation: AggregationType | undefined,
    onAggregationChange: (aggregation: AggregationType) => void
    setError: (error: string) => void
}

export const FIELD_TYPES_WITH_AGGREGATION = [FieldType.Link, FieldType.Date, FieldType.Number, FieldType.Decimal];

export function FieldAggregationForm({ fieldType, fieldTypeItems, fieldAggregation, onAggregationChange, setError }: FieldAggregationFormProps) {

    const [aggregation, setAggregation] = useState<AggregationType>(AggregationType.NO_AGGR);
    const { t } = useTranslation();


    useEffect(() => {
        if (fieldAggregation) {
            setAggregation(fieldAggregation);
        } else {
            setAggregation(AggregationType.NO_AGGR);
        }
    }, [fieldAggregation]);

    const validAggregationTypes = fieldType ? validAggregationByType(fieldType, fieldTypeItems) : [AggregationType.NO_AGGR];

    const changeAggregation = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const aggregationType = event.target.value as AggregationType;
        setAggregation(aggregationType);
        onAggregationChange(aggregationType);
    }

    return (
        <div className={TW_FieldAggregationSection}>
            <p className={TW_FieldAggregationSection_Label}>{t("field.aggregation.label")}</p>

            <select className={TW_FieldAggregationSection_Select} value={aggregation} onChange={changeAggregation}>
                {Array.from(validAggregationTypes).map((aggregationType) => {
                    let i18nKey = "field.aggregation.label." + aggregationType;
                    return <option key={"field-aggregation-" + aggregationType} value={aggregationType} className="text-base">{t(i18nKey)}</option>
                })}
            </select>
        </div>
    )
}